export default __webpack_public_path__ + "static/media/slider-bubble-primary-03.7b60ae2d.svg";